import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Panel } from "primereact/panel";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useRef, useState } from "react";
import {
  everyReminderTypeUnit,
  onceReminderTypeUnit,
  perParticipantOptions,
  reminderType,
} from "../../../../../utils/constants";
import { ProgressSpinner } from "primereact/progressspinner";
import { isEmptyCheck } from "../../../../../utils/commonLogics";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

const productUsedConditions = [
  { label: "Time of Day", value: 2 },
  { label: "Day of Week", value: 3 },
  { label: "Time of Day & Day of Week", value: 4 },
];

const timeOfDayOptions = [
  { label: "Overnight(12AM - 6AM)", value: "1" },
  { label: "Early Morning(6AM - 9AM)", value: "2" },
  { label: "Daynight(9AM - 4PM)", value: "3" },
  { label: "Early Fringe(4PM - 7PM)", value: "4" },
  { label: "Primetime(7PM - 11PM)", value: "5" },
  { label: "Last Night(11PM - 12PM)", value: "6" },
];

const dayOfWeekOptions = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

const stopXmots = [
  { label: "Credit Limit", value: 1 },
  // { label: "Participant Limit", value: 2 }, //hide participant limit option for this release due to under development
  { label: "Date limit", value: 3 },
];

const noOfTimeProductUsedOptions = [
  { name: "1", code: 1 },
  { name: "2", code: 2 },
  { name: "3", code: 3 },
  { name: "4", code: 4 },
  { name: "5", code: 5 },
  { name: "6", code: 6 },
  { name: "7", code: 7 },
  { name: "8", code: 8 },
  { name: "9", code: 9 },
  { name: "10", code: 10 },
];
const weekOfTimeProductUsed = [
  { name: "Day", code: 1 },
  { name: "Week", code: 2 },
  { name: "Month", code: 3 },
];

const TimelineAndReminder = ({
  errors,
  xmotFormData,
  handleXmotFormChange,
  durationUnitOptions,
  handleErrors,
  loading,
  isLocked,
  stopXmotCreditValue = null,
}) => {
  const { reminder, timeline, seletedCustomRecruit } = xmotFormData;
  const {
    reminderSwitch,
    sendReminderToggler,
    reminderTypeUnitValue,
    reminderTypeValue,
    reminderTime,
    reminderText,
  } = reminder;
  const {
    timelineSelection,
    windowLength,
    expireDuration,
    durationUnit,
    nextTimeProductUsed,
    noOfUsageEvent,
    noOfTimeProductUsed,
    typeOfProductUsed,
    productUsedWithCondition,
    stopXmotBasedOn,
    stopXmotValue,
    triggerTimelineType,
    xmotLimitType,
  } = timeline;
  const errorRef = useRef({});

  useEffect(() => {
    const firstErrorKey =
      errors &&
      Object.keys(errors).length > 0 &&
      !isEmptyCheck(Object.values(errors)[0])
        ? Object.keys(errors)[0]
        : null;

    if (firstErrorKey) {
      const el = errorRef.current[firstErrorKey];
      if (el) {
        el?.scrollIntoView({ behavior: "smooth", block: "center" });
        el?.focus();
      }
    }
  }, [errors]);

  const handleReminderType = (event) => {
    console.log("event", event);
    reminder.reminderTypeValue = event;
    handleXmotFormChange("reminder", reminder);
    if (event === 1) {
      reminder.reminderTypeUnitValue = onceReminderTypeUnit[0].code;
      reminder.sendReminderToggler = true;
      handleXmotFormChange("reminder", reminder);
    } else {
      reminder.reminderTypeUnitValue = everyReminderTypeUnit[0].code;
      reminder.sendReminderToggler = false;
      handleXmotFormChange("reminder", reminder);
    }
  };

  const XmotWindowSection = () => {
    return (
      <>
        <div className="d-flex flex-column pt-3">
          <div className="d-flex align-items-center">
            <label className="fs-14">XMOT window length</label>
            <div ref={(el) => (errorRef.current.windowLength = el)}>
              <InputNumber
                className={`m-2 inputField ${errors?.windowLength ? "error-input" : ""}`}
                min={1}
                value={windowLength}
                max={999}
                onValueChange={(e) => {
                  timeline.windowLength = e.value;
                  handleXmotFormChange("timeline", timeline);
                }}
                id="window-length-value"
                disabled={isLocked}
              />
            </div>
            <label className="fs-14">minutes</label>
          </div>
        </div>
        <div className="d-flex flex-column pt-2">
          <div className="d-flex align-items-center">
            <span
              className="pi pi-info-circle text-secondary"
              style={{ fontSize: "18px" }}
            ></span>
            <label className="fs-12 ms-2">
              Window of time that has to elapse between two events
            </label>
          </div>
        </div>
        <div className="d-flex flex-column pt-5 pb-4">
          <label className="mb-1 fs-14">
            Expire each XMOT if not completed in
          </label>
          <div className="d-flex align-items-center gap-2 mb-3">
            <InputNumber
              id="expire-duration"
              min={1}
              value={expireDuration}
              ref={(el) => (errorRef.current.expireDuration = el)}
              onValueChange={(e) => {
                timeline.expireDuration = e.value;
                handleXmotFormChange("timeline", timeline);
              }}
              className={`inputField fs-14 ${errors?.expireDuration ? "error-input" : ""}`}
              disabled={isLocked}
            />
            <Dropdown
              value={durationUnit}
              onChange={(e) => {
                timeline.durationUnit = e.value;
                handleXmotFormChange("timeline", timeline);
              }}
              options={durationUnitOptions}
              optionLabel="name"
              optionValue="code"
              style={{ width: "140px" }}
              className="inputField fs-14"
              disabled={isLocked}
            />
          </div>
        </div>
      </>
    );
  };

  const OneTimeView = () => {
    return (
      <div className="px-3 mt-3">
        <Divider />
        <div className="d-flex align-items-center mt-3">
          <RadioButton
            inputId="next_time_product_used"
            name="nextTimeProductUsed"
            value="next_time_product_used"
            onChange={(e) => {
              timeline.nextTimeProductUsed = e.target.value;
              timeline.trigger_xmot_onetime_type = 1;
              handleXmotFormChange("timeline", timeline);
            }}
            checked={nextTimeProductUsed === "next_time_product_used"}
            disabled={isLocked}
          />
          <label htmlFor="next_time_product_used" className="ms-2 fs-14">
            Next time the product is used
          </label>
        </div>
        <div className="d-flex align-items-center mt-3">
          <RadioButton
            inputId="next_time_product_used_with_condition"
            name="nextTimeProductUsed"
            value="next_time_product_used_with_condition"
            onChange={(e) => {
              timeline.nextTimeProductUsed = e.target.value;
              timeline.trigger_xmot_onetime_type = 2;
              handleXmotFormChange("timeline", timeline);
            }}
            checked={
              nextTimeProductUsed === "next_time_product_used_with_condition"
            }
            disabled={true}
          />
          <label
            htmlFor="next_time_product_used_with_condition"
            className="ms-2 fs-14 opacity-75"
          >
            Next time product is used based on following condition
          </label>
        </div>
        {errors?.nextTimeProductUsed ? (
          <div
            className="text-start fs-14 text-danger"
            ref={(el) => (errorRef.current.nextTimeProductUsed = el)}
          >
            {errors?.nextTimeProductUsed}
          </div>
        ) : (
          ""
        )}
        {nextTimeProductUsed === "next_time_product_used_with_condition" ? (
          <ProductUsedWithConditions />
        ) : (
          ""
        )}

        <div className="pt-4 pb-3">
          <XmotWindowSection />

          <div className="d-flex flex-column">
            <div className="mb-1 fs-14">Participant Limit</div>
            <div className="d-flex align-items-center pt-2">
              <label className="fs-14">1 XMOT</label>
              <Dropdown
                value={xmotLimitType}
                onChange={(e) => {
                  timeline.xmotLimitType = e.value;
                  handleXmotFormChange("timeline", timeline);
                }}
                options={perParticipantOptions}
                optionLabel="name"
                optionValue="code"
                style={{ width: "150px" }}
                className="inputField fs-14 mx-3"
                disabled={isLocked}
              />
              <label className="fs-14">per participant</label>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const OnGoingView = () => {
    return (
      <div className="px-3 mt-3">
        <Divider />
        <div className="d-flex align-items-center mt-3">
          <RadioButton
            inputId={"every_time_product_used"}
            name="product_used"
            value={4}
            onChange={(e) => {
              timeline.triggerTimelineType = e.target.value;
              timeline.triggerTimelineValue = "";
              handleXmotFormChange("timeline", timeline);
            }}
            checked={triggerTimelineType === 4}
            disabled={isLocked}
          />
          <label htmlFor={"every_time_product_used"} className="ms-2 fs-14">
            Every time the product is used
          </label>
        </div>

        <div className="d-flex align-items-center mt-3">
          <RadioButton
            inputId={"every_no_of_usage_event"}
            name="product_used"
            value={5}
            onChange={(e) => {
              timeline.triggerTimelineType = e.target.value;
              handleXmotFormChange("timeline", timeline);
            }}
            checked={triggerTimelineType === 5}
            disabled={isLocked}
          />
          <label htmlFor={"every_no_of_usage_event"} className="ms-2 fs-14">
            <div ref={(el) => (errorRef.current.noOfUsageEventErr = el)}>
              <span className="me-2">Every</span>
              <InputNumber
                className={`inputField ${errors?.noOfUsageEventErr ? "error-input" : ""}`}
                min={2}
                value={noOfUsageEvent}
                onValueChange={(e) => {
                  timeline.noOfUsageEvent = e.value;
                  timeline.triggerTimelineValue = e.target.value;
                  handleXmotFormChange("timeline", timeline);
                }}
                disabled={isLocked}
              />
              <span className="ms-2">usage events</span>
            </div>
          </label>
        </div>

        <div className="d-flex align-items-center mt-3">
          <RadioButton
            inputId={"no_of_time_used"}
            name="product_used"
            onChange={(e) => {
              timeline.triggerTimelineType = 1;
              timeline.triggerTimelineValue = 1;
              handleXmotFormChange("timeline", timeline);
            }}
            checked={
              triggerTimelineType === 1 ||
              triggerTimelineType === 2 ||
              triggerTimelineType === 3
            }
            disabled={isLocked}
          />
          <label htmlFor={"no_of_time_used"} className="ms-2 fs-14">
            <span className="me-2">Up to</span>
            <Dropdown
              value={noOfTimeProductUsed}
              onChange={(e) => {
                timeline.noOfTimeProductUsed = e.value;
                timeline.triggerTimelineValue = e.value;
                handleXmotFormChange("reminder", timeline);
              }}
              options={noOfTimeProductUsedOptions}
              optionLabel="name"
              optionValue="code"
              style={{ width: "100px" }}
              className="inputField"
              disabled={isLocked}
            />
            <span className="mx-2">time(s) in a</span>
            <Dropdown
              value={typeOfProductUsed}
              onChange={(e) => {
                timeline.typeOfProductUsed = e.value;
                timeline.triggerTimelineType = e.value;
                handleXmotFormChange("reminder", timeline);
              }}
              options={weekOfTimeProductUsed}
              optionLabel="name"
              optionValue="code"
              style={{ width: "100px" }}
              className="inputField"
              disabled={isLocked}
            />
          </label>
        </div>

        {errors?.noOfUsageEventErr ? (
          <div className="text-start fs-14 text-danger">
            {errors?.noOfUsageEventErr}
          </div>
        ) : (
          ""
        )}

        {errors?.triggerTimelineTypeErr ? (
          <div
            className="text-start fs-14 text-danger"
            ref={(el) => (errorRef.current.triggerTimelineTypeErr = el)}
          >
            {errors?.triggerTimelineTypeErr}
          </div>
        ) : (
          ""
        )}

        <div className="pt-4 pb-3">
          <XmotWindowSection />
        </div>

        <div className="heading mt-3 px-3">Stop XMOTs based on</div>

        <div className="px-3 mt-2">
          <div className="d-flex align-items-center gap-3">
            {stopXmots.map((stopXmot, index) => (
              <div className="d-flex align-items-center mt-3" key={index}>
                <div className="d-flex align-items-center">
                  <RadioButton
                    inputId={stopXmot.value}
                    name="stop_xmot_basedon"
                    value={stopXmot.value}
                    onChange={(e) => {
                      timeline.stopXmotBasedOn = e.target.value;
                      timeline.stopXmotValue = "";
                      handleErrors("stopXmotValue", "");
                      handleXmotFormChange("timeline", timeline);
                    }}
                    checked={stopXmotBasedOn === stopXmot.value}
                    disabled={isLocked}
                  />
                  <label htmlFor={stopXmot.value} className="ms-2 fs-14">
                    {stopXmot.label}
                  </label>
                </div>
              </div>
            ))}
          </div>

          {errors?.stopXmotBasedOn ? (
            <div
              className="text-start fs-14 text-danger"
              ref={(el) => (errorRef.current.stopXmotBasedOn = el)}
            >
              {errors?.stopXmotBasedOn}
            </div>
          ) : (
            ""
          )}

          {stopXmotBasedOn === 1 ? (
            <div className="px-5 mt-3">
              <Divider />
              <div className="d-flex align-items-center mt-3 mb-1">
                <div>Apply</div>
                <div ref={(el) => (errorRef.current.stopXmotValue = el)}>
                  <InputNumber
                    className={`inputField mx-3 ${errors?.stopXmotValue ? "error-input" : ""}`}
                    min={2}
                    value={stopXmotValue}
                    onValueChange={(e) => {
                      if (
                        isLocked &&
                        parseInt(e.value) < parseInt(stopXmotCreditValue)
                      ) {
                        timeline.stopXmotValue = stopXmotValue;
                        handleXmotFormChange("timeline", timeline);
                        return false;
                      }
                      timeline.stopXmotValue = e.value;
                      handleXmotFormChange("timeline", timeline);
                    }}
                    onBlur={(e) => {
                      if (
                        isLocked &&
                        stopXmotCreditValue &&
                        parseInt(e.target.value) > parseInt(stopXmotCreditValue)
                      ) {
                        confirmCreditLimit(stopXmotCreditValue, e.target.value);
                      }
                    }}
                  />
                </div>
                <div>Credit to XMOT</div>
              </div>
              <div>
                <small>
                  Min <span className="fw-600">10</span> to{" "}
                  <span className="fw-600">
                    {seletedCustomRecruit?.xmot_credits}
                  </span>{" "}
                  credits available
                </small>
                {errors?.stopXmotValue ? (
                  <div className="text-start fs-14 text-danger">
                    {errors?.stopXmotValue}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          {stopXmotBasedOn === 2 ? (
            <>
              <div className="px-5 mt-3">
                <Divider />
                <div className="d-flex align-items-center mt-3">
                  <div ref={(el) => (errorRef.current.stopXmotValue = el)}>
                    <InputNumber
                      className={`inputField ${errors?.stopXmotValue ? "error-input" : ""}`}
                      min={2}
                      value={stopXmotValue}
                      onValueChange={(e) => {
                        timeline.stopXmotValue = e.value;
                        handleXmotFormChange("timeline", timeline);
                      }}
                      disabled={isLocked}
                    />
                  </div>
                  <div className="ps-2">XMOT(s)</div>
                  <Dropdown
                    value={xmotLimitType}
                    onChange={(e) => {
                      timeline.xmotLimitType = e.value;
                      handleXmotFormChange("timeline", timeline);
                    }}
                    options={perParticipantOptions}
                    optionLabel="name"
                    optionValue="code"
                    style={{ width: "150px" }}
                    className="inputField fs-14 mx-2"
                    disabled={isLocked}
                  />
                  <div>Per Participant</div>
                </div>
              </div>
              <div className="d-flex flex-column pt-5">
                <div className="d-flex align-items-center">
                  <span
                    className="pi pi-info-circle text-secondary"
                    style={{ fontSize: "18px" }}
                  ></span>
                  <label className="fs-12 ms-2">
                    Regardless of selections made, XMOTs will stop upon reaching
                    the credit limit.
                  </label>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {stopXmotBasedOn === 3 ? (
            <>
              <div className="px-5 mt-3">
                <Divider />
                <div ref={(el) => (errorRef.current.stopXmotValue = el)}>
                  <Calendar
                    ref={(el) => (errorRef.current.stopXmotValue = el)}
                    className={`mt-3 inputField ${errors?.stopXmotValue ? "error-input" : ""}`}
                    placeholder="MM/DD/YYYY"
                    value={new Date(stopXmotValue)}
                    minDate={new Date()}
                    onChange={(e) => {
                      const selected = new Date(e.value);
                      selected.setHours(12, 0, 0, 0); // Set time to noon to avoid timezone issues
                      let datePayload = {
                        date: selected.toISOString(),
                      };
                      timeline.stopXmotValue = datePayload.date;
                      handleXmotFormChange("timeline", timeline);
                    }}
                    disabled={isLocked}
                  />
                </div>
              </div>

              <div className="d-flex flex-column pt-5">
                <div className="d-flex align-items-center">
                  <span
                    className="pi pi-info-circle text-secondary"
                    style={{ fontSize: "18px" }}
                  ></span>
                  <label className="fs-12 ms-2">
                    Regardless of selections made, XMOTs will stop upon reaching
                    the credit limit.
                  </label>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  const confirmCreditLimit = (oldValue, newValue) => {
    confirmDialog({
      message: (
        <>
          <div className="mt-3">
            You are increasing the credit limit from {oldValue} to {newValue}.
            This cannot be undone.
          </div>
          <div className="mt-3">
            Are you sure you want to increase the credit limit?
          </div>
        </>
      ),
      header: "Confirmation",
      defaultFocus: "accept",
      acceptClassName: "createClientBtn",
      rejectClassName: "cancel me-2",
      accept: () => {
        console.log("accept");
      },
      reject: () => {
        const timelineData = { ...timeline };
        timelineData.stopXmotValue = oldValue;
        handleXmotFormChange("timeline", timelineData);
      },
    });
  };

  const ProductUsedWithConditions = () => {
    return (
      <>
        <div className="px-3 mt-3 d-flex align-items-center gap-3">
          {productUsedConditions.map((productUsedCondition, index) => (
            <div className="d-flex align-items-center mt-3" key={index}>
              <div className="d-flex align-items-center">
                <RadioButton
                  inputId={productUsedCondition.value}
                  name="product_used_condition"
                  value={productUsedCondition.value}
                  onChange={(e) => {
                    timeline.trigger_xmot_onetime_type = e.target.value;
                    timeline.productUsedWithCondition.selectedDayConditionValue =
                      [];
                    timeline.productUsedWithCondition.selectedWeekConditionValue =
                      [];
                    handleXmotFormChange("timeline", timeline);
                  }}
                  checked={
                    timeline.trigger_xmot_onetime_type ===
                    productUsedCondition.value
                  }
                  disabled={isLocked}
                />
                <label
                  htmlFor={productUsedCondition.value}
                  className="ms-2 fs-14"
                >
                  {productUsedCondition.label}
                </label>
              </div>
            </div>
          ))}
        </div>
        {timeline.trigger_xmot_onetime_type === 2 ? (
          <div className="px-4 mt-3">
            <Divider />
            <div className="my-3 d-flex align-items-center flex-wrap gap-3">
              {timeOfDayOptions.map((timeOfDayOption, index) => (
                <div
                  className="d-flex align-items-center pt-2 pb-2"
                  key={index}
                >
                  <Checkbox
                    inputId={`timeOfDayOption-${index}`}
                    value={timeOfDayOption.value}
                    onChange={(e) => {
                      const { value, checked } = e.target;

                      if (timeline?.productUsedWithCondition) {
                        const selected =
                          timeline.productUsedWithCondition
                            .selectedDayConditionValue || [];

                        timeline.productUsedWithCondition.selectedDayConditionValue =
                          checked
                            ? [...selected, value]
                            : selected.filter((v) => v !== value);
                      }

                      handleXmotFormChange("timeline", timeline);
                    }}
                    checked={productUsedWithCondition.selectedDayConditionValue?.includes(
                      timeOfDayOption.value,
                    )}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={`timeOfDayOption-${index}`}
                    className="ml-2 ps-2 fs-14"
                  >
                    {timeOfDayOption.label}
                  </label>
                </div>
              ))}
            </div>
            {errors?.selectedDayConditionValue ? (
              <div className="px-5 text-start fs-14 text-danger">
                {errors?.selectedDayConditionValue}
              </div>
            ) : (
              ""
            )}
            <Divider />
          </div>
        ) : (
          ""
        )}

        {timeline.trigger_xmot_onetime_type === 3 ? (
          <div className="px-4 mt-3">
            <Divider />
            <div className="my-3 d-flex align-items-center flex-wrap gap-4">
              {dayOfWeekOptions.map((timeOfDayOption, index) => (
                <div
                  className="d-flex align-items-center pt-2 pb-2"
                  key={index}
                >
                  <Checkbox
                    inputId={`dayOfweekOption-${index}`}
                    value={timeOfDayOption.value}
                    onChange={(e) => {
                      const { value, checked } = e.target;

                      if (timeline?.productUsedWithCondition) {
                        const selected =
                          timeline.productUsedWithCondition
                            .selectedWeekConditionValue || [];

                        timeline.productUsedWithCondition.selectedWeekConditionValue =
                          checked
                            ? [...selected, value]
                            : selected.filter((v) => v !== value);
                      }

                      handleXmotFormChange("timeline", timeline);
                    }}
                    checked={productUsedWithCondition.selectedWeekConditionValue?.includes(
                      timeOfDayOption.value,
                    )}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={`dayOfweekOption-${index}`}
                    className="ml-2 ps-2 fs-14"
                  >
                    {timeOfDayOption.label}
                  </label>
                </div>
              ))}
            </div>
            {errors?.selectedWeekConditionValue ? (
              <div className="px-5 text-start fs-14 text-danger">
                {errors?.selectedWeekConditionValue}
              </div>
            ) : (
              ""
            )}
            <Divider />
          </div>
        ) : (
          ""
        )}

        {timeline.trigger_xmot_onetime_type === 4 ? (
          <div className="px-4 mt-3">
            <Divider />
            <div className="mt-3 d-flex align-items-center flex-wrap gap-4">
              {timeOfDayOptions.map((timeOfDayOption, index) => (
                <div
                  className="d-flex align-items-center pt-2 pb-2"
                  key={index}
                >
                  <Checkbox
                    inputId={`timeOfDayOption-${index}`}
                    value={timeOfDayOption.value}
                    onChange={(e) => {
                      const { value, checked } = e.target;

                      if (timeline?.productUsedWithCondition) {
                        const selected =
                          timeline.productUsedWithCondition
                            .selectedDayConditionValue || [];

                        timeline.productUsedWithCondition.selectedDayConditionValue =
                          checked
                            ? [...selected, value]
                            : selected.filter((v) => v !== value);
                      }

                      handleXmotFormChange("timeline", timeline);
                    }}
                    checked={productUsedWithCondition.selectedDayConditionValue?.includes(
                      timeOfDayOption.value,
                    )}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={`timeOfDayOption-${index}`}
                    className="ml-2 ps-2 fs-14"
                  >
                    {timeOfDayOption.label}
                  </label>
                </div>
              ))}
            </div>
            <div className="px-4 mt-3 d-flex justify-content-center">
              <Divider />
              <div className="fw-600 px-3 fs-14">AND</div>
              <Divider />
            </div>
            <div className="px-4 my-3 d-flex align-items-center flex-wrap gap-4">
              {dayOfWeekOptions.map((timeOfDayOption, index) => (
                <div
                  className="d-flex align-items-center pt-2 pb-2"
                  key={index}
                >
                  <Checkbox
                    inputId={`dayOfweekOption-${index}`}
                    value={timeOfDayOption.value}
                    onChange={(e) => {
                      const { value, checked } = e.target;

                      if (timeline?.productUsedWithCondition) {
                        const selected =
                          timeline.productUsedWithCondition
                            .selectedWeekConditionValue || [];

                        timeline.productUsedWithCondition.selectedWeekConditionValue =
                          checked
                            ? [...selected, value]
                            : selected.filter((v) => v !== value);
                      }

                      handleXmotFormChange("timeline", timeline);
                    }}
                    checked={productUsedWithCondition.selectedWeekConditionValue?.includes(
                      timeOfDayOption.value,
                    )}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={`dayOfweekOption-${index}`}
                    className="ml-2 ps-2 fs-14"
                  >
                    {timeOfDayOption.label}
                  </label>
                </div>
              ))}
            </div>

            {errors?.selectedDayWeekConditionErr ? (
              <div className="px-5 text-start fs-14 text-danger">
                {errors?.selectedDayWeekConditionErr}
              </div>
            ) : (
              ""
            )}
            <Divider />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <div className="mt-4 text-start">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration="0.5s"
          />
        </div>
      )}
      <div className="row my-4">
        <div className="col-md-12">
          <div className="form-label fw-600 d-block text-start dark-text">
            XMOT Timeline
          </div>

          <div className="d-flex flex-column pt-3">
            <div className="d-flex align-items-center">
              <div className="me-3 d-flex align-items-center">
                <RadioButton
                  inputId="one_time"
                  name="timelineSelection"
                  value={1}
                  onChange={(e) => {
                    timeline.timelineSelection = e.target.value;
                    timeline.nextTimeProductUsed = "next_time_product_used";
                    timeline.triggerTimelineType = "";
                    timeline.triggerTimelineValue = "";
                    timeline.trigger_xmot_onetime_type = 1;
                    handleXmotFormChange("timeline", timeline);
                  }}
                  checked={timelineSelection === 1}
                  disabled={isLocked}
                />
                <label htmlFor="one_time" className="ms-2 fs-14">
                  One-time
                </label>
              </div>

              <div className="me-3 d-flex align-items-center">
                <RadioButton
                  inputId="ongoing"
                  name="timelineSelection"
                  value={2}
                  onChange={(e) => {
                    timeline.timelineSelection = e.target.value;
                    timeline.nextTimeProductUsed = "";
                    // timeline.triggerTimelineType = 4;
                    handleXmotFormChange("timeline", timeline);
                  }}
                  checked={timelineSelection === 2}
                  disabled={isLocked}
                />
                <label htmlFor="ongoing" className="ms-2 fs-14">
                  Ongoing
                </label>
              </div>
            </div>

            {errors?.timelineSelection ? (
              <div className="text-start fs-14 text-danger">
                {errors?.timelineSelection}
              </div>
            ) : (
              ""
            )}

            {timelineSelection === 1 ? <OneTimeView /> : ""}

            {timelineSelection === 2 ? <OnGoingView /> : ""}
          </div>
        </div>
      </div>

      <Divider />

      <div className="d-flex align-items-center justify-content-between mt-4">
        <div className="form-label fw-600 d-block text-start dark-text">
          Reminders
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted small">
            {reminderSwitch ? "On" : "Off"}
          </span>
          <InputSwitch
            checked={reminderSwitch}
            onChange={(e) => {
              // Stop propagation from both React synthetic event and native DOM event
              e.originalEvent && e.originalEvent.stopPropagation();
              e.stopPropagation?.(); // fallback if originalEvent isn't defined
              reminder.reminderSwitch = e.value;
              handleXmotFormChange("reminder", reminder);
            }}
            onClick={(e) => {
              e.stopPropagation(); // ensures click doesn't bubble
            }}
            className="custom-smooth-switch"
          />
        </div>
      </div>

      <div className="d-flex flex-column pt-3">
        <label className="mb-1 fs-14">Send reminder</label>
        <div className="d-flex align-items-center gap-2 mb-3">
          <Dropdown
            value={reminderTypeValue}
            onChange={(e) => handleReminderType(e.value)}
            options={reminderType}
            optionLabel="name"
            optionValue="code"
            style={{ width: "140px" }}
            className="inputField fs-14"
            disabled={!reminderSwitch} // Disable if reminderSwitch is OFF
          />
          {sendReminderToggler && <label>in</label>}
          <InputNumber
            ref={(el) => (errorRef.current.reminderTime = el)}
            min={1}
            value={reminderTime}
            onValueChange={(e) => {
              reminder.reminderTime = e.value;
              handleXmotFormChange("reminder", reminder);
            }}
            className={`inputField ${errors?.reminderTime || (reminderTypeUnitValue === 2 && reminder.reminderTime < 5) ? "error-input" : ""}`}
            disabled={!reminderSwitch} // Disable if reminderSwitch is OFF
          />

          <Dropdown
            value={reminderTypeUnitValue}
            onChange={(e) => {
              reminder.reminderTypeUnitValue = e.value;
              handleXmotFormChange("reminder", reminder);
            }}
            options={
              sendReminderToggler ? onceReminderTypeUnit : everyReminderTypeUnit
            }
            optionLabel="name"
            optionValue="code"
            style={{ width: "140px" }}
            className="inputField"
            disabled={!reminderSwitch} // Disable if reminderSwitch is OFF
          />
          {!sendReminderToggler && (
            <label className="fs-14">
              For 24 hours (Unless XMOT expires earlier)
            </label>
          )}
        </div>
        {reminderTypeUnitValue === 2 && reminder.reminderTime < 5 ? (
          <div
            className="text-start fs-14 text-danger mb-3"
            style={{ marginLeft: "140px" }}
          >
            Time cannot be less than 5 minutes
          </div>
        ) : (
          ""
        )}
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center">
            <span
              className="pi pi-exclamation-circle text-secondary"
              style={{ fontSize: "18px" }}
            ></span>
            <label className="fs-12 fw-600 ms-2">
              This notification will only be sent to participants between 8 AM
              to 8 PM in their time zone.
            </label>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column pt-3">
        <label className="mb-1 fs-14">Reminder Text</label>
        <div className="d-flex flex-column gap-2 mb-3">
          <InputTextarea
            ref={(el) => (errorRef.current.reminderText = el)}
            className={`w-100 inputField fs-14 ${errors?.reminderText ? "error-input" : ""}`}
            autoResize
            value={reminderText}
            onChange={(e) => {
              reminder.reminderText = e.target.value;
              handleXmotFormChange("reminder", reminder);
            }}
            rows={3}
            disabled={!reminderSwitch} // Disable if reminderSwitch is OFF
          />
          {errors?.reminderText ? (
            <div className="text-start fs-14 text-danger">
              {errors?.reminderText}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Divider />
      <ConfirmDialog />
    </div>
  );
};

export default TimelineAndReminder;
